import { FC } from 'react'
import PageLayout from '../../../../../components/page-layout/page-layout'
import { useParams, useSearchParams } from 'react-router-dom'
import StampForm from './components/stamp-form/stamp-form'
import { Breadcrumb } from 'antd'
import { useGetStampByDocIdQuery } from '../../../../../store/api/stamps-api'
import useBreadcrumbItems from './hooks/use-breadcrumb-items'

interface StampPageProps {}

const StampPage: FC<StampPageProps> = () => {
    const { docId = 'new' } = useParams()
    const [searchParams] = useSearchParams()
    const copyBy = searchParams.get('copyBy')
    const isNew = docId === 'new'
    const id = copyBy || (isNew ? '' : docId)

    const { data, isSuccess } = useGetStampByDocIdQuery([id, { populate: '*' }], { skip: !id })

    const stampNumber = data?.data.number || ''
    const title = isNew ? 'Новый штамп' : `Штамп № ${stampNumber}`
    const breadcrumbItems = useBreadcrumbItems(isNew ? '' : stampNumber)

    return (
        <PageLayout title={title}>
            <Breadcrumb items={breadcrumbItems} />
            {id && isSuccess ? (
                <StampForm stamp={data.data} copy={!!copyBy} key={'editing'} />
            ) : (
                <StampForm key={'creating'} />
            )}
        </PageLayout>
    )
}

export default StampPage
